import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import MeteringDevices from './MeteringDevices';
import MeteringHistory from './MeteringHistory';
import MeteringOrders from './MeteringOrders';
import { ContentNav } from '../_common';

export default function BroadCast() {
 return (
  <>
   <ContentNav
    links={[
     { name: 'Передача показаний', path: '/broadcast/metering' },
     {
      name: 'История показаний',
      path: '/broadcast/metering-history',
     },
     {
      name: 'Заявки по приборам учета',
      path: '/broadcast/metering-orders',
     },
    ]}
   />
   <Switch>
    <Route path="/broadcast/metering" component={MeteringDevices} />
    <Route path="/broadcast/metering-history" component={MeteringHistory} />
    <Route
     path="/broadcast/metering-orders"
     component={MeteringOrders as any}
    />
    <Route render={() => <Redirect to="/broadcast/metering" />} />
   </Switch>
  </>
 );
}
